import * as tslib_1 from "tslib";
import { Notification } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var NotificationsApi = /** @class */ (function () {
    function NotificationsApi(apollo) {
        this.apollo = apollo;
    }
    NotificationsApi.prototype.subscribe = function (pushSubscription) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var CREATE_SUBSCRIPTION, input;
            return tslib_1.__generator(this, function (_a) {
                CREATE_SUBSCRIPTION = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      mutation createSubscription($input: SubscribeInput!) {\n        subscribe(input: $input) {\n          id\n        }\n      }\n    "], ["\n      mutation createSubscription($input: SubscribeInput!) {\n        subscribe(input: $input) {\n          id\n        }\n      }\n    "])));
                input = {
                    type: 'browser',
                    data: pushSubscription,
                    app: 'mountdoom'
                };
                return [2 /*return*/, this.apollo.use('mordu').mutate({
                        mutation: CREATE_SUBSCRIPTION,
                        variables: { input: input }
                    }).toPromise()
                        .then(function (result) { return result.data['subscribe']['id']; })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return null;
                    })];
            });
        });
    };
    NotificationsApi.prototype.unsubscribe = function (subscriptionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var UNSUBSCRIBE;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        UNSUBSCRIBE = gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      mutation unsubscribe($id: ID!) {\n        unsubscribe(id: $id)\n      }\n    "], ["\n      mutation unsubscribe($id: ID!) {\n        unsubscribe(id: $id)\n      }\n    "])));
                        return [4 /*yield*/, this.apollo.use('mordu').mutate({
                                mutation: UNSUBSCRIBE,
                                variables: { id: subscriptionId }
                            }).toPromise()
                                .then(function (result) { return result.data['unsubscribe']; })
                                .catch(function (err) {
                                sentry.captureException(err);
                                return null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsApi.prototype.listNotifications = function (_a) {
        var before = _a.before, take = _a.take;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var LIST_NOTIFICATIONS;
            return tslib_1.__generator(this, function (_b) {
                LIST_NOTIFICATIONS = gql(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query listNotifications($before: Datetime, $take: Int) {\n        notifications(before: $before, take: $take) {\n          id\n          type\n          data\n          readAt\n          createdAt\n        }\n      }\n    "], ["\n      query listNotifications($before: Datetime, $take: Int) {\n        notifications(before: $before, take: $take) {\n          id\n          type\n          data\n          readAt\n          createdAt\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo.use('mordu')
                        .query({
                        query: LIST_NOTIFICATIONS,
                        variables: {
                            before: before,
                            take: take
                        }
                    }).toPromise()
                        .then(function (response) {
                        if (response.data && response.data['notifications']) {
                            return response.data['notifications'];
                        }
                        return [];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return [];
                    })];
            });
        });
    };
    NotificationsApi.prototype.getNotificationsUnreadCount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var GET_NOTIFICATIONS_UNREAD_COUNT;
            return tslib_1.__generator(this, function (_a) {
                GET_NOTIFICATIONS_UNREAD_COUNT = gql(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      query getNotificationsUnreadCount {\n        notificationsUnreadCount {\n          count\n        }\n      }\n    "], ["\n      query getNotificationsUnreadCount {\n        notificationsUnreadCount {\n          count\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo.use('mordu')
                        .query({
                        query: GET_NOTIFICATIONS_UNREAD_COUNT,
                    }).toPromise()
                        .then(function (response) { return response.data['notificationsUnreadCount']['count']; })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return null;
                    })];
            });
        });
    };
    NotificationsApi.prototype.readNotification = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var READ_NOTIFICATION;
            return tslib_1.__generator(this, function (_a) {
                READ_NOTIFICATION = gql(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      mutation notificationRead($id: ID!) {\n        notificationRead(id: $id) {\n          id\n          readAt\n        }\n      }\n    "], ["\n      mutation notificationRead($id: ID!) {\n        notificationRead(id: $id) {\n          id\n          readAt\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo.use('mordu')
                        .query({
                        query: READ_NOTIFICATION,
                        variables: {
                            id: id
                        }
                    }).toPromise()
                        .then(function (response) {
                        if (response.data && response.data['notificationRead']) {
                            return response.data['notificationRead'];
                        }
                        return null;
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return null;
                    })];
            });
        });
    };
    NotificationsApi.prototype.readAllNotifications = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var READ_ALL_NOTIFICATIONS;
            return tslib_1.__generator(this, function (_a) {
                READ_ALL_NOTIFICATIONS = gql(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      mutation notificationReadAll {\n        notificationReadAll {\n          count\n        }\n      }\n    "], ["\n      mutation notificationReadAll {\n        notificationReadAll {\n          count\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo.use('mordu')
                        .query({
                        query: READ_ALL_NOTIFICATIONS,
                    }).toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data['notificationReadAll']['count'];
                    })
                        .catch(function (err) {
                        sentry.captureException(err);
                        return null;
                    })];
            });
        });
    };
    NotificationsApi.prototype.syncUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var SYNC_USER;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        SYNC_USER = gql(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      mutation syncUser {\n        syncUser {\n          id\n        }\n      }\n    "], ["\n      mutation syncUser {\n        syncUser {\n          id\n        }\n      }\n    "])));
                        return [4 /*yield*/, this.apollo.use('mordu')
                                .mutate({ mutation: SYNC_USER })
                                .toPromise()
                                .catch(function (err) { return sentry.captureException(err); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NotificationsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationsApi_Factory() { return new NotificationsApi(i0.ɵɵinject(i1.Apollo)); }, token: NotificationsApi, providedIn: "root" });
    return NotificationsApi;
}());
export { NotificationsApi };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
